import React from 'react';
import logo from '../images/gif-720.gif';
import heroBg from '../images/main.jpg';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    console.log(`Scrolling to ${sectionId}...`);
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = 80; // Offset for navbar
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - navHeight,
        behavior: 'smooth'
      });
    } else {
      console.warn(`Element with id ${sectionId} not found.`);
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>
      </div>
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Your body can stand almost anything. <span className="highlight-text">It's your mind that you have to convince.</span>
          </h1>

          <div className="hero-badges">
            <div className="responsive-circle">
              <div className="hero-circle">
                <img src={logo} alt="Be Safe Keep Safe" className="hero-logo-img" />
                <div className="accent-circle accent-circle-1"></div>
                <div className="accent-circle accent-circle-2"></div>
              </div>
            </div>
            <div className="badges-list">
              <div className="floating-card card-1">
                <div className="card-icon">🛡️</div>
                <span>Safety First</span>
              </div>
              <div className="floating-card card-2">
                <div className="card-icon">✓</div>
                <span>NEBOSH Certified</span>
              </div>
              <div className="floating-card card-3">
                <div className="card-icon">📋</div>
                <span>Risk Assessment</span>
              </div>
            </div>
          </div>

          <p className="hero-description">
            Professional health and safety consultancy services to create safer work 
            environments for businesses of all sizes.
          </p>
          <div className="hero-buttons">
            <button 
              className="btn-primary"
              onClick={() => scrollToSection('contact')}
            >
              Get in Touch Now
            </button>
            <button 
              className="btn-secondary"
              onClick={() => scrollToSection('services')}
            >
              Learn More
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-image-container">
            <div className="hero-circle">
              <img src={logo} alt="Be Safe Keep Safe" className="hero-logo-img" />
              <div className="accent-circle accent-circle-1"></div>
              <div className="accent-circle accent-circle-2"></div>
            </div>
          </div>
        </div>
      </div>
      <div 
        className="scroll-indicator" 
        onClick={() => scrollToSection('services')}
        style={{ cursor: 'pointer' }}
      >
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <span>Scroll Down</span>
      </div>
    </section>
  );
};

export default Hero;
